import { DefaultFormatRegistry } from '@cs/common';

export class HBFormatRegistry extends DefaultFormatRegistry {

	constructor() {
		super();
		this.options.nullAsZero = false;
	}
}